import React, { useState, useEffect } from 'react';
import { Form, Upload, Button, Icon, Input, Radio, Popover, Select, Tooltip } from 'antd';
import { BulkUploadBatch } from '../../../../models/batch';
import { Text4, Text5 } from '../../../../styles';
import { connect } from 'react-redux';
import { PROVIDER_PAYMENT_MODE_MESSAGES } from '../../../../constants';
import { QuickTransfer, Beneficiary } from '../../../../models';
import { getBankLogo } from '../../../../constants';


let BulkUploadForm = (props) => {
    const { form } = props;
    const { getFieldDecorator } = form;
    const validations = BulkUploadBatch.validations;
    const file = props.form.getFieldValue('file') || null;


    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (err) return;
            props.onSubmit(form.getFieldsValue());
        });
    };

    const renderNotes = () => {
        const instructions = PROVIDER_PAYMENT_MODE_MESSAGES[props.current_user.virtual_account.provider_code] || {};
        const messages = Object.keys(instructions).map(payment_mode => instructions[payment_mode].node)
        let record_limit = 0
        if (props.batch_type == "beneficiary"){
            record_limit = props.current_user.bbul
        } else if(props.batch_type == "transfer"){
            record_limit = props.current_user.tbul
        } else if(props.batch_type == "instacollect_order"){
            record_limit = props.current_user.iobul
        } else if(props.batch_type == "penny_drop"){
            record_limit = props.current_user.bulk_penny_drop_upload_limit
        } else if(props.batch_type == "advanced_penny_drop"){
            record_limit = props.current_user.bulk_advanced_penny_drop_upload_limit
        }
        else if(props.batch_type == "payout_link"){
            record_limit = props.current_user?.payout_link_bulk_upload_limit || 0
        }
        return (
            <>
                {props.batch_type?<Text5 className="d-block">• Maximum { record_limit } records can be uploaded at a time.</Text5>:<Text5 className="d-block"> Please select batch type</Text5>}
                {
                    props.batch_type == "transfer" && messages.map(message => <Text5 className="d-block">• {message}</Text5>)
                }
            </>
        )
    };

    const renderThresholdPercentLabelIcon = () => {
        return (
          <div className="d-inline-flex m-0 align-items-center">
            Match Percentage Threshold
            <Tooltip placement="right" title={`If not provided, match percentage threshold will be considered as ${props?.current_user?.fuzzy_check_threshold_percentage}%`}>
              <Icon style={{color: "#1890ff"}} className="ml-2" type="exclamation-circle" />
            </Tooltip>
          </div>
        );
      };

    return (
        <Form onSubmit={onSubmit}>
            <Form.Item>
                {getFieldDecorator("queue_on_low_balance", {
                    initialValue: props.merchant.eqlb
                })(<Input autoComplete='off' hidden />)}
                {getFieldDecorator("batch_type", {
                    initialValue: props.batch_type
                })(<Input autoComplete='off' type="hidden" />)}
            </Form.Item>
            <Form.Item label="Batch Name">
                {getFieldDecorator('name', {
                    rules: validations.name
                })(<Input autoComplete='off' />)}
            </Form.Item>
            {props.batch_type==="transfer"?
                <Form.Item label="Source Virtual Account">
                {getFieldDecorator("virtual_account_number", {
                    rules: QuickTransfer.validations.virtual_account_number,
                    initialValue: props.current_user.virtual_account.virtual_account_number
                })(<Select>
                    {
                        props.current_user.virtual_accounts.filter(va => va.status == "active").map((va, index) => {
                            return (
                                <Select.Option value={va.virtual_account_number} disabled={va.funding_via==2 && !props.current_user.allow_payouts_via_cc_va? true : false}>
                                    <div className="d-flex">
                                        <div
                                            style={{
                                                display: "flex",
                                                width: 28,
                                                overflow: "hidden",
                                                textAlign: "center",
                                                marginRight: 8
                                            }}
                                        >
                                            <img
                                                style={{
                                                    margin: "auto",
                                                    width: "auto",
                                                    maxWidth: "100%",
                                                    maxHeight: 28
                                                }}
                                                alt=""
                                                src={getBankLogo(va.provider_code)}
                                            />
                                        </div>
                                        <Text4 className="mr-1">{va.label}</Text4>
                                    </div>
                                </Select.Option>
                            )
                        })
                    }
                </Select>)}
                </Form.Item>
            :null}
            <Form.Item>
                {getFieldDecorator('file', {
                    valuePropName: 'file',
                    rules: validations.file
                })(
                    <Upload.Dragger
                        name='file'
                        multiple={false}
                        showUploadList={false}
                        className="pl-0 pb-2 d-block"
                        beforeUpload={(file) => {
                            return false;
                        }}
                    >
                        <p className="ant-upload-drag-icon"><Icon type="inbox" /></p>
                        {
                            file ? (
                                <div>
                                    <Text4 strong>Selected File:</Text4>
                                    <Text4 className="ml-2">
                                        {(file || {}).fileList[(file || {}).fileList.length - 1].name}
                                    </Text4>
                                </div>
                            ) : <div>
                                    <Text4 className="d-block">Click or drag file to this area to upload</Text4>
                                </div>
                        }
                    </Upload.Dragger>
                )}
            </Form.Item>
            {props.batch_type === "advanced_penny_drop" && 
                <Form.Item label={renderThresholdPercentLabelIcon()}>
                    {getFieldDecorator('threshold_percentage', {
                        rules: validations.threshold_percentage
                    })(<Input autoComplete='off' />)}
                </Form.Item>
            }
            <div className="w-100 d-flex justify-content-between mt-4">
                <Popover
                    overlayStyle={{ maxWidth: 600 }}
                    content={renderNotes()}
                    placement="top"
                    trigger="click"
                >
                    <Button className="pl-0" type="link">Notes</Button>
                </Popover>
                <Button type="primary" htmlType="submit" loading={props.loading}>{props.submitText || "Submit"}</Button>
            </div>
        </Form>
    )
};

BulkUploadForm = Form.create()(BulkUploadForm);

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

BulkUploadForm = connect(mapStateToProps, null)(BulkUploadForm);

export { BulkUploadForm };